"use client";
import React from "react";
import Image from "next/image";
import { Center, Heading, Stack, Text } from "@chakra-ui/react";
import { useTextVariants } from "@/theme/components/useSectionHeading";
import { OFFERING_CONSTANTS } from "./constants";

const VeeamGraphics = () => {
  const { title, text, image } = OFFERING_CONSTANTS;
  const textVariant = useTextVariants();
  return (
    <Stack spacing={6}>
      <Heading
        as="h2"
        fontWeight={"400"}
        fontSize={"40px"}
        whiteSpace={"pre-line"}
        textAlign={"center"}
      >
        {title}
      </Heading>
      <Text
        textAlign={"center"}
        variant={textVariant}
        color={"text.100"}
        fontWeight={600}
      >
        {text}
      </Text>
      <Center>
        <Image
          src={image}
          alt="Veeam Offerings"
          style={{ height: "auto", maxWidth: "600px", width: "100%" }}
        />
      </Center>
    </Stack>
  );
};

export default VeeamGraphics;
